import axios from 'axios';
import * as Cookie from 'tiny-cookie';

export const createTopicBookmark = (topicId: number) => {
  return axios.put(
    `/api/v3/bookmarks/topics/${topicId}`,
    {},
    {
      headers: { 'X-CSRFToken': Cookie.get('csrftoken') },
    },
  );
};

export const deleteTopicBookmark = (topicId: number) => {
  return axios.put(
    `/api/v3/bookmarks/topics/${topicId}/delete`,
    {},
    {
      headers: { 'X-CSRFToken': Cookie.get('csrftoken') },
    },
  );
};
